import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Control, useController } from 'react-hook-form'

import { Option } from 'types/option'

interface Props {
  control: Control<any>
  name: string
  options: Option[]
}

export default function CheckboxGroup(props: Props) {
  const { control, name, options } = props

  return (
    <>
      {options.map((option) => {
        const { field } = useController({
          name: `${name}.${option.value}`,
          control,
          defaultValue: false,
        })

        return (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            }
            label={option.label}
          />
        )
      })}
    </>
  )
}
